import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {MaybeExpanded} from '../../../../../api/types';
import type {UserExpandedCommon} from '../../../../../api/user';
import type {EventContextsMap, EventData} from '../types';

import AlarmIcon from '../../../../../assets/icons/alarm.svg';
import {getYcLogoFile} from '../../../../../utils/entity/file';
import {isUserHasRole} from '../../../../../utils/entity/user';

/**
 * @see https://github.com/yourcoach/backend-bnrks/blob/f372bda22f66a3427408305c7010e75817e92408/src/yourcoach/messages/push.py#L401
 */
export const getData = (
  event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {user} = contexts;

  // this event contains two user ids in its context
  const client = (event.contexts.find(
    item => !isUserHasRole('coach', item as UserExpandedCommon),
  ) || user) as MaybeExpanded<UserExpandedCommon>;

  let matchedHoursAgo = 4;
  let messageKey = 'send_welcome_message_to_client';

  const clientName = client?.name || i18n.t('shared:user_not_found');

  if (event.type === 'coach_didnt_send_1st_message_2') {
    matchedHoursAgo = 14;
    messageKey = 'send_welcome_message_to_client_obligation';
  }

  const title =
    /**
     * @i18n_parser
     *
     * t('shared:send_welcome_message_to_client')
     * t('shared:send_welcome_message_to_client_obligation')
     */
    i18n.t(`shared:${messageKey}`, {
      clientName,
      hoursAgo: i18n.t('shared:hours_ago', {count: matchedHoursAgo}),
    });

  return {
    avatar: getYcLogoFile(180),
    avatarPlaceholder: 'Your Coach',
    icon: AlarmIcon,
    iconGradient: 'danger',
    title,
  };
};
